export default {
  ev: 'init',
  data: {
    apiKey: '5d5d62276301323e6d021325',
    env: 'homolog',
    productInfo: {
      name: 'Pera ......',
      price: 2200,
      value: 2200,
      imageUrl: 'https://imagem.com.br',
    },
    preQualifyId: '1fe175fe-a4de-4826-8443-2e19dc43ee09',
    trackId: 'track-0',
  },
};
